import ko from "@tko/build.knockout";
import { onEvent } from "../_dom";
import { debounce } from "../debounce";
import { highlight, unhighlight } from "../highlight";

class AppLibraryModel {
	constructor(data) {
		this.data = data ?? [];
		this.selectedCategory = ko.observable("");
		this.userQuery = ko.observable(null);
	}

	categories = ko.pureComputed(() => {
		const cid = this.selectedCategory();
		return this.data.map(c => ({ id: c.id, title: c.title, description: c.description, selected: id === cid }));
	});

	/* { id, title, apps: { title, description, href, more } } */
	results = ko.pureComputed(() => {
		let re = this.userQuery();
		if(re) {
			return { id: "search", title: "Search Results", description: "", apps: this.data.flatMap(c => c.apps).filter(app => re.test(app.title) || re.test(app.description)) };
		}
		else {
			let q = this.selectedCategory();
			return this.data.find(c => c.id === q) ?? { id: "notfound", title: "Not Found", description: "", apps: [] };
		}
	});
}

export function initApplicationLibrary(context) {
	var categorySelector = document.getElementById("td-appcategories");
	const libraryRoot = document.getElementById("td-applibrary");
	if(!categorySelector || !libraryRoot)
		return;

	const data = JSON.parse(libraryRoot.dataset.library);

	const defaultCategory = data[0].id;

	const model = new AppLibraryModel(data);

	ko.applyBindings(model, libraryRoot);

	const selectedClass = "v3-state-selected";
	const appCategoryPrefix = "#appcategory_";

	onEvent(categorySelector, `.v3-applibrary__category-link`, "click", (e, newCategory) => {
		e.preventDefault();
		const currentCategory = categorySelector.querySelector(`.v3-applibrary__category-link.${selectedClass}`);
		if(newCategory != currentCategory) {
			currentCategory?.classList.remove(selectedClass);
			newCategory.classList.add(selectedClass);
			const hash = newCategory.getAttribute("href");
			const catid = hash.substring(appCategoryPrefix.length);
			if(model.userQuery()) {
				model.userQuery(null);
				searchBox.value = "";
			}
			model.selectedCategory(catid);

			const newUrl = new URL(window.location.href);
			newUrl.hash = hash;
			history.pushState({}, "", newUrl);
		}
	});

	processHashChange = () => {
		let catid = location.hash;
		if(catid.startsWith(appCategoryPrefix)) {
			catid = catid.substring(appCategoryPrefix.length)
			catid = model.data.some(c => c.id === catid) ? catid : defaultCategory;
		} else {
			catid = defaultCategory;
		}
		model.selectedCategory(catid);
		const currentCategory = categorySelector.querySelector(`.v3-applibrary__category-link.${selectedClass}`);
		currentCategory?.classList.remove(selectedClass);
		const newCategory = categorySelector.querySelector(`.v3-applibrary__category-link[href="${appCategoryPrefix}${catid}"]`);
		newCategory?.classList.add(selectedClass);
	}

	window.addEventListener("popstate", processHashChange);

	processHashChange();

	var searchBox = context.querySelector("#td-mysearchbox");
	if(searchBox != null) {
		searchBox.disabled = false;
		searchBox.nextElementSibling.disabled = false;
		searchBox.addEventListener("input", debounce(e => {
			const w = e.target.value.split(" ").filter(w => w.trim() !== "");
			const re = w.length ? new RegExp(w.map(w => w.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&")).join(".*"), "i") : null;
			model.userQuery(re);
			const libraryView = libraryRoot.querySelector(".v3-tileview");
			setTimeout(highlight, 0, libraryView, w);
		}, 300));
	}
}